import { InjectionToken } from '@angular/core';

/* ================================
 * Types
 * ================================ */

export interface PaymentResource {
  Url: string;
  Properties: Record<string, any>;
  ResourceContentType: string;
}

export interface PaymentProviderTemplateOptions {
  component: any;
  options?: Record<string, any>;
}

/* ================================
 * Injection Tokens
 * ================================ */

export const PAYMENT_TEMPLATES = new InjectionToken<Record<string, PaymentProviderTemplateOptions>>('paymentTemplates', {
  providedIn: 'root',
  factory: () => {
    console.warn('No payment templates provided! Please provide providePaymentConfig() in your AppModule.');
    return {};
  },
});
